<template>
  <div class="bookmarks-list">
    <div class="flex-wrapper">

      <div class="bookmark"
           v-for="bookmark in bookmarks">
        <div class="wrap">
          <h4>{{ bookmark.bookmark_name }}</h4>

          <span class="btn-delete" @click="removeBookmark(bookmark.id)"></span>
        </div>

        <p class="light" v-if="bookmark.book">{{ bookmark.book.name }}</p>

        <router-link
            class="btn"
            :to="{
                  name: 'pages.book',
                  params: {id: bookmark.book_id},
                  query: {page: bookmark.page_number}
              }"
        >
          Bekijk
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
} from "vuex";

export default {
  name: "Bookmarks",
  props: [
    "bookmarks",
  ],
  methods: {
    ...mapActions("bookmark", [
      "deleteBookmark",
    ]),
    removeBookmark(id) {
      this.deleteBookmark(id).then(() => {
        this.$emit("updated");
      });
    },
  },
};
</script>
